import React from 'react';
import generateRiskReportPdf from '../../util/generateRiskReportPdf';
import { useIntl } from '../../util/reactIntl';

import { PrimaryButton, SecondaryButton } from '../Button/Button';


import css from './Result.module.css';

function Result({ result, onRestart }) {
  const intl = useIntl();

  const riskDescription = intl.formatMessage({
    id: result.summary,
  });

  const singleLoss = intl.formatMessage({
    id: result.singleLoss,
  });

  const seasonLoss = intl.formatMessage({
    id: result.seasonLoss,
  });

  const badge = intl.formatMessage({
    id: result.badge,
  });

  const openAppointment = () => {
    window.open(
      'https://cal.com/david-guardup.de/termin-zum-kostenlosen-risiokocheck-ihres-standorts',
      '_blank'
    );
  };

  // const downloadPDF = () => {
  //   generateRiskReportPdf({
  //     percentage: result.percentage,
  //     badge,
  //     summary: riskDescription,
  //     singleLoss,
  //     seasonLoss,
  //     color: result.color,
  //   });
  // };
  const downloadPDF = () => {
  generateRiskReportPdf(result.percentage);
};

  return (
    <div className={css.root}>

      {/* =====================================================
          NORMAL RESULT
      ===================================================== */}

      <div className={css.resultCard}>

        <h2 className={css.resultTitle}>
          {intl.formatMessage({ id: 'RiskCalculator.result.title' })}
        </h2>

        <div className={css.resultLines}>
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>

        <div className={css.resultBox}>

          <span
            className={css.badge}
            style={{
              backgroundColor: result.color,
            }}
          >
            {badge}
          </span>

          <div className={css.scoreRow}>
            <span className={css.score}>
              {result.percentage}
            </span>

            <span className={css.scoreLabel}>
              {intl.formatMessage({ id: 'RiskCalculator.result.riskPoints' })}
            </span>
          </div>

          <div className={css.progress}>
            <div
              className={css.progressFill}
              style={{
                width: `${result.percentage}%`,
                backgroundColor: result.color,
              }}
            />
          </div>

          <p className={css.summary}>
            {riskDescription}
          </p>

          <hr className={css.divider} />

          <div className={css.financialRow}>
            <span>
              {intl.formatMessage({id: 'RiskCalculator.result.singleLossTitle'})}
              {/* <br /> */}
              {intl.formatMessage({id: 'RiskCalculator.result.singleLossSubtitle'})}
            </span>

            <strong className={css.lossValue}>
              {singleLoss}
            </strong>
          </div>

          <div className={css.financialRow}>
            <span>
              {intl.formatMessage({id: 'RiskCalculator.result.seasonLossTitle'})}
              {/* <br /> */}
              {intl.formatMessage({id: 'RiskCalculator.result.seasonLossSubtitle'})}
            </span>

            <strong>
              {seasonLoss}
            </strong>
          </div>

        </div>

        <div className={css.actionCards}>

          <div className={css.appointmentCard}>

            <div className={css.cardIcon}>
              📅
            </div>

            <h3 className={css.cardTitle}>
              {intl.formatMessage({ id: 'RiskCalculator.result.appointmentTitle' })}
              <br />
              {intl.formatMessage({ id: 'RiskCalculator.result.appointmentTitle.br' })}
            </h3>

            <p className={css.cardDescription}>
              {intl.formatMessage({ id: 'RiskCalculator.result.appointmentDescription' })}
            </p>

            <PrimaryButton onClick={openAppointment}>
              {intl.formatMessage({ id: 'RiskCalculator.result.appointmentButton' })}
            </PrimaryButton>

          </div>

          <div className={css.pdfCard}>

            <div className={css.cardIcon}>
              📄
            </div>

            <h3>
              {intl.formatMessage({ id: 'RiskCalculator.result.pdfTitle' })}
            </h3>

            <p>
              {intl.formatMessage({ id: 'RiskCalculator.result.pdfDescription' })}
            </p>

            <SecondaryButton onClick={downloadPDF}>
              {intl.formatMessage({ id: 'RiskCalculator.result.pdfButton' })}
            </SecondaryButton>

          </div>

        </div>

        <p className={css.disclaimer}>
          {intl.formatMessage({ id: 'RiskCalculator.result.disclaimer' })}
        </p>

              <div className={css.restartContainer}>

        <button
          type="button"
          className={css.restartLink}
          onClick={onRestart}
        >
          {intl.formatMessage({ id: 'RiskCalculator.result.restart' })}
        </button>
              </div>

      </div>




    </div>
  );
}

export default Result;